import { render, staticRenderFns } from "./BindsDrawer.vue?vue&type=template&id=30cfd3ae&"
import script from "./BindsDrawer.vue?vue&type=script&lang=js&"
export * from "./BindsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BindsDrawer.vue?vue&type=style&index=0&id=30cfd3ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports